import {
  Box,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

type ValidatorFilterType = "all" | "yes" | "no";

interface TemplateSearchFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  validatorFilter: ValidatorFilterType;
  onValidatorFilterChange: (value: ValidatorFilterType) => void;
}

const TemplateSearchFilters = ({
  searchTerm,
  onSearchChange,
  validatorFilter,
  onValidatorFilterChange,
}: TemplateSearchFiltersProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        gap: 2,
        mb: 2,
        backgroundColor: (theme) => theme.palette.background.paper,
      }}
    >
      <TextField
        placeholder="Search templates..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          flex: 1,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            "&:hover fieldset": {
              borderColor: "primary.main",
            },
          },
        }}
      />
      <FormControl sx={{ minWidth: 240 }}>
        <InputLabel>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <FilterListIcon fontSize="small" />
            Filter by Validator
          </Box>
        </InputLabel>
        <Select
          value={validatorFilter}
          label="Filter by Validator"
          onChange={(e) =>
            onValidatorFilterChange(e.target.value as "all" | "yes" | "no")
          }
          sx={{
            borderRadius: 2,
          }}
        >
          <MenuItem value="all">All Templates</MenuItem>
          <MenuItem value="yes">✓ Used in Validator</MenuItem>
          <MenuItem value="no">✗ Not Used in Validator</MenuItem>
        </Select>
      </FormControl>
    </Paper>
  );
};

export default TemplateSearchFilters;
